import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from 'semantic-ui-react';
import { get, isEmpty } from 'lodash';


export const FormInputField = ({
  field, form: {
    setFieldValue, values, touched, errors
  }, otherProps, ...props
}) => {
  const {
    label,
    type,
    placeholder,
    hint,
    textarea
  } = otherProps;

  const [value, setValue] = useState(isEmpty(get(values, `${field.name}`)) ? '' : get(values, `${field.name}`));

  const hasError = !!(touched[field.name] && errors[field.name]);

  const handleOnChange = e => {
    setValue(e.target.value);
    setFieldValue(field.name, e.target.value);
  };

  if (textarea) {
    return (
      <Block>
        { label && (
        <Label>{label}</Label>
        )}
        <TextWrapper
          name={label}
          max-length='500'
          value={value}
          onChange={handleOnChange}
          {...props}
        />
        {
            hint && (
            <HintText>{hint}</HintText>
            )
        }
        {
            hasError && (
            <ErrorText>{errors[field.name]}</ErrorText>
            )
        }
      </Block>
    );
  }

  return (
    <Block isName={type === 'text'}>
      { label && (
      <Label>{label}</Label>
      )}
      <InputWrapper
        type={type}
        name={type}
        placeholder={placeholder}
        value={value}
        onChange={handleOnChange}
        {...props}
      />
      {
        hint && (
        <HintText>{hint}</HintText>
        )
      }
      {
        hasError && (
        <ErrorText>{errors[field.name]}</ErrorText>
        )
        }
    </Block>
  );
};

// FormInputField.defaultProps = {
//   type: 'text',
//   label: undefined,
//   placeholder:'',
//   hint: undefined,
//   textarea: false,
// }

export const FormSubmitButton = ({ isSubmitting, label, isSecondary, ...props }) => (
  <BtnWrapper
    // isSecondary={isSecondary}
    primary
    fluid
    disabled={isSubmitting}
    loading={isSubmitting}
    className={isSecondary ? 'btn secondary' : 'btn'}
    type='submit'
    size='medium'
    {...props}
  >{label}
  </BtnWrapper>
);

FormSubmitButton.defaultProps = {
  isSecondary: false
}

const Block = styled.div`
  margin: 0.4em 0;
  display: inline-flex;
  flex-direction: column;
  width: ${(props) => (props.isName ? '224px' : '480px')};
`;

const Label = styled.label`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #344054;
  padding-bottom: 0.1em;
`;

const InputWrapper = styled.input.attrs((props) => ({
  type: props.type
}))`
  width: 100%;
  height: 48px;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  outline: none;
  color: #101828

  ::placeholder {
    color: #667085;
  }
  :disabled {
    background: #f1f4f9;
    color: #667085;
  }
  :focus {
    border: 1px solid #0094fb;
  }
  :invalid {
    border: 1px solid #FDA29B
  }
`;

const TextWrapper = styled.textarea`
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  outline: none;
  min-height: 128px;
  max-height: 128px;
  color: #101828

  ::placeholder {
    color: #667085;
  }
  :disabled {
    background: #f1f4f9;
    color: #667085;

  }
  :focus {
    border: 1px solid #0094fb;
  }
  :invalid {
    border: 1px solid #FDA29B
  }
`;

const HintText = styled.small`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #667085;
`;

const ErrorText = styled(HintText)`
  color: #F04438;
`;

// background-color: ${(props) => (props.isSecondary ? '#06152B' : '#0094FB')};
// opacity:  ${(props) => (props.isSecondary ? '0.2' : '1')}
  // &&&&:hover:enabled {
  //   background-color:${(props) => (props.isSecondary ? '#06152B' : '#0094fb')};
  //   opacity: ${(props) => (props.isSecondary ? '0.4' : '0.8')};
  // }
const BtnWrapper = styled(Button)`
  &&&& {
    background-color: #0094FB;
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    width:100%;
    opacity: 1;

    &&&&.secondary {
      background-color: '#06152B'
      opacity: 0.2
    }
  }

  &&&&:hover:enabled {
    background-color: #0094fb;
    opacity: 0.8;
  }
  &&&&.secondary:hover:enabled {
    background-color: #06152B;
    opacity: 0.4;
  }
`;



// WEBPACK FOOTER //
// ./src/uiStandard/event/formInput.js